import {
    Component,
    Input,
    OnChanges,
    OnInit,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from '@angular/core';

import { DateUtils } from '../dateutils.service';
import * as moment from 'moment';

@Component({
    selector: 'main-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit, OnChanges {

    @Input() date : Date

    constructor(private ref : ChangeDetectorRef, private dateutils : DateUtils) { }

    weekNumber(date : Date) {
        return moment(date).isoWeek();
    }

    today() {
        return ["/date", "today"];
    }

    weekUrl(date : Date) {
        return this.dateutils.weekUrl(date);
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.ref.markForCheck();
    }

}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/main/sidebar.component.ts